import { SVGProps } from 'react';

export type WarnIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

export const WarningCircleIcon = ({ color = '#FAB27D', ...props }: WarnIconProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16675 12.5001H10.8334V14.1667H9.16675V12.5001ZM9.16675 5.83341H10.8334V10.8334H9.16675V5.83341ZM9.99175 1.66675C5.39175 1.66675 1.66675 5.40008 1.66675 10.0001C1.66675 14.6001 5.39175 18.3334 9.99175 18.3334C14.6001 18.3334 18.3334 14.6001 18.3334 10.0001C18.3334 5.40008 14.6001 1.66675 9.99175 1.66675ZM10.0001 16.6667C6.31675 16.6667 3.33341 13.6834 3.33341 10.0001C3.33341 6.31675 6.31675 3.33341 10.0001 3.33341C13.6834 3.33341 16.6667 6.31675 16.6667 10.0001C16.6667 13.6834 13.6834 16.6667 10.0001 16.6667Z"
      fill={color}
    />
  </svg>
);
